import * as React from "react";
import type { DateFormat, TimeFormat } from "@/types/user";

export interface LocaleContextValue {
  dateFormat: DateFormat;
  timeFormat: TimeFormat;
}

export const LocaleContext = React.createContext<LocaleContextValue | undefined>(undefined);

export const useLocale = () => {
  const context = React.useContext(LocaleContext);
  if (context === undefined) {
    throw new Error("useLocale must be used within a LocaleProvider");
  }
  return context;
};
